import React, { useRef } from "react";
import { Grid, Paper, Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import OrderDetailsFetcher from "./OrderDetails/OrderData/OrderDetailsFetcher";
import ProductBrowser from "../tables/OrderDetails/ProductBrowser/ProductBrowesrMain";
import InvoiceCreator from "./OrderDetails/InvoiceCreator/InvoiceCreatorMain";

const TableModalContent = ({
  type,
  tableId,
  rootId,
  onSuccess,
  onClose,
  onOrderDeleted,
  orderId,
  onOrderChanged,
}) => {
  const reloadDetailsRef = useRef(null);
  const navigate = useNavigate();
  const scrollBoxRef = useRef(null);

  const handleScrollDown = () => {
    if (scrollBoxRef.current) {
      scrollBoxRef.current.scrollTop = scrollBoxRef.current.scrollHeight;
    }
  };

  return (
    <Grid
      container
      spacing={{ xs: 1, sm: 2 }}
      sx={{
        flexDirection: { xs: "column-reverse", md: "row" },
        alignItems: "stretch",
      }} 
    >
      {/* Left Section - Product Browser */}
      <Grid
        item
        xs={12}
        md={8}
        sx={{
          order: { xs: 2, md: 1 },
          mb: { xs: 2, md: 0 },
          display: "flex",
          flexDirection: "column",
        }}
      >
        {type === "addItem" && orderId && (
<ProductBrowser
  orderId={orderId}
  onSuccess={() => {
    if (typeof reloadDetailsRef.current === "function") {
      reloadDetailsRef.current();
    }
    if (typeof onOrderChanged === "function") {
      onOrderChanged(); // ✅ يحدث total على كارت الطاولة
    }
  }}
/>
        )}
      </Grid>

      {/* Right Section - Order Details */}
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          order: { xs: 1, md: 2 },
          mb: { xs: 2, md: 0 },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          sx={{
            p: { xs: 1, sm: 2 },
            bgcolor: "#1e1e2f",
            color: "#fff",
            height: "100%",
            minHeight: { xs: "auto", md: "400px" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Box
            ref={scrollBoxRef}
            sx={{
              flex: 1,
              overflowY: "auto",
              minHeight: 0,
              maxHeight: { xs: 600, md: "calc(100vh - 100px)" },
              pr: 1,
              // إخفاء شريط الاسكرول
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {orderId && (
              <>
                <OrderDetailsFetcher
                  orderId={orderId}
                  onReload={(fn) => (reloadDetailsRef.current = fn)}
                  onClose={onClose}
                  onOrderDeleted={onOrderDeleted}
                />

                <InvoiceCreator
                  orderId={orderId}
                  onSuccess={() => {
                    if (onSuccess) onSuccess();
                    if (onClose) onClose();
                    if (typeof onOrderChanged === "function") {
                      onOrderChanged(); // ✅ يحدث total على كارت الطاولة
                    }
                    navigate("/tables");
                  }}
                />
              </>
            )}
          </Box>
          {/* زر النزول للأسفل */}
          <Box
            sx={{
              position: "absolute",
              left: 10,
              bottom: 10,
              zIndex: 10,
              bgcolor: "#232334",
              borderRadius: "50%",
              boxShadow: 2,
            }}
          >
            <IconButton
              size="large"
              color="primary"
              onClick={handleScrollDown}
              sx={{
                bgcolor: "#fbc2eb",
                color: "#232334",
                "&:hover": { bgcolor: "#ff9a9e" },
                width: 40,
                height: 40,
              }}
            >
              <KeyboardArrowDownIcon />
            </IconButton>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TableModalContent;

